/* Rocco — ajustes globais de layout */
(function () {
  function fixGap() {
    var pre = document.querySelector('.rkb-pre');
    var list = document.querySelector('.product-form__info-list');
    if (!pre || !list) return;
    var wrap = pre.closest('.product-info__block-item') || pre;
    wrap.style.marginTop = '0px';
    var gap = wrap.getBoundingClientRect().top - list.getBoundingClientRect().bottom;
    var target = 8;
    wrap.style.marginTop = (target - gap) + 'px';
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(fixGap, 120); }
  document.addEventListener('DOMContentLoaded', function () { fixGap(); setTimeout(fixGap, 500); setTimeout(fixGap, 1500); });
  window.addEventListener('load', fixGap);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fixGap);
})();
